import { Button, Container } from 'components/atoms';
import World from 'components/atoms/world/World';
import Banner from 'components/molecules/banners/Banner';
import ReleaseCard from 'components/molecules/card/release/ReleaseCard';
import DashboardTotalCard from 'components/molecules/card/total/DashboardTotalCard';
import { TopbarPage } from 'components/templates';
import { useFormSave } from 'hooks/useFormSave';
import { useIsUserBanned } from 'hooks/useIsUserBanned';
import { useStoreState } from 'providers/StoreStateContext';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PiCaretLeft,
  PiCaretRight,
  PiCaretUpFill,
  PiChartBar,
  PiChartBarHorizontal,
  PiChartLine,
  PiGlobeHemisphereEast,
  PiVinylRecord,
} from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { formatCurrency } from 'utils/global/currency.utils';

const Dashboatrd = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [chartView, setChartView] = useState<'line' | 'bar'>('line');

  const mockedViews = useMemo(() => {
    const data = [];
    const today = new Date();

    for (let i = 6; i >= 0; i--) {
      const date = new Date();
      date.setDate(today.getDate() - i);

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const name = `${day}.${month}`;

      // Losowanie od 5000 do 100000
      const value = Math.floor(Math.random() * (100000 - 5000 + 1)) + 5000;

      data.push({ value, name });
    }

    return data;
  }, []);

  const mockedTotalSettlements = useMemo(
    () => Math.floor(Math.random() * (500000 - 100000 + 1)) + 100000,
    [],
  );
  const mockedLastSettlement = useMemo(
    () => Math.floor(Math.random() * (50000 - 10000 + 1)) + 10000,
    [],
  );
  const mockedLastSettlementStats = useMemo(
    () => Math.floor(Math.random() * (50 - 10 + 1)) + 10,
    [],
  );

  const countriesViews = useMemo(() => generateCountryViews(), []);

  const { isBanned } = useIsUserBanned();

  const { isAnyFormSaved } = useFormSave();

  const { clearForms } = useStoreState();

  return (
    <TopbarPage topbar={<div />}>
      {!isBanned && (
        <Banner
          description="Sprawdź siebie, nie masz na co czekać...."
          title="Opublikuj swoją muzykę już teraz!"
          hint="Kliknij w baner, aby przejścia do intuicyjnego formularza wydania twojej muzyki."
          onClick={() => {
            clearForms();
            navigate('/music-product-digital/create/tracks');
          }}
        />
      )}
      <div />
      <div />
      <div className="flex flex-col gap-4 w-full md:flex-row">
        <div className="flex flex-col gap-4 min-w-[20rem]">
          <DashboardTotalCard
            label={'Łączne zarobki'}
            value={formatCurrency(mockedTotalSettlements)}
            variant={BUTTON_VARIANT.submit}
          />
          <DashboardTotalCard
            label={'W ostatnim miesiącu'}
            value={
              <>
                {formatCurrency(mockedLastSettlement)}
                <p className="flex items-center text-base" style={{ color: 'var(--green)' }}>
                  <PiCaretUpFill /> {mockedLastSettlementStats}%
                </p>
              </>
            }
          />
          <div className="flex gap-4 w-full">
            <DashboardTotalCard label={'Wydania'} value={'230'} variant={BUTTON_VARIANT.submit} />
            <DashboardTotalCard label={'Katalog'} value={'612'} />
          </div>
        </div>
        <Container className="statistics-home-track ">
          <Container.Header
            title={
              <div className=" flex w-full justify-between">
                <div className="flex gap-2">
                  <PiVinylRecord /> Odsłuchania
                </div>
              </div>
            }
          >
            <div className="info-box-items flex p-4 w-full min-h-0 max-w-96">
              <Button
                onlyIcon
                isClear={chartView !== 'bar'}
                variant={BUTTON_VARIANT.background}
                onClick={() => setChartView('bar')}
              >
                <Button.Icon icon={<PiChartBar />} />
              </Button>
              <Button
                onlyIcon
                isClear={chartView !== 'line'}
                variant={BUTTON_VARIANT.background}
                onClick={() => setChartView('line')}
              >
                <Button.Icon icon={<PiChartLine />} />
              </Button>
            </div>
          </Container.Header>
          <Container.Content
            style={{ backgroundColor: 'var(--background)', padding: '20px 0px' }}
            //   loading={isSectionLoading(trackEarnings.isLoading)}
          >
            {chartView === 'line' && (
              <ResponsiveContainer width={'100%'} height={298}>
                <LineChart
                  data={mockedViews}
                  margin={{
                    top: 20,
                    right: 60,
                    bottom: 20,
                  }}
                >
                  <CartesianGrid strokeDasharray="" vertical={false} opacity={0.5} />
                  <XAxis dataKey="name" stroke="var(--secondary)" />
                  <YAxis
                    width={100}
                    stroke="var(--secondary)"
                    tickFormatter={(value: any, index: number) =>
                      value === 0 ? '' : value.toLocaleString('en-US').replaceAll(',', ' ')
                    }
                    tickCount={5}
                  />
                  <Tooltip
                    cursor={{ fill: 'none' }}
                    content={(props) => (
                      <div
                        className="flex  bg-opacity-95 rounded-sm p-8 gap-3"
                        style={{ backgroundColor: 'var(--background)' }}
                      >
                        <p>{`${props.label}`}</p>
                        {props.payload && props.payload[0] && (
                          <>
                            <p>-</p>
                            <p style={{ color: props.payload[0].color }}>
                              {parseFloat(`${props.payload[0].value}`)}
                            </p>
                          </>
                        )}
                      </div>
                    )}
                  />
                  <ReferenceLine y={0} stroke="var(--secondary)" />

                  <Line
                    type="monotone"
                    dataKey="value"
                    strokeWidth={3}
                    fill="var(--primary)"
                    stroke="var(--primary)"
                    activeDot={{ r: 6 }}
                    style={{ boxShadow: '0rem 0.5rem 1rem var(--primary)' }}
                  />
                </LineChart>
              </ResponsiveContainer>
            )}
            {chartView === 'bar' && (
              <ResponsiveContainer width={'100%'} height={298}>
                <BarChart
                  data={mockedViews}
                  margin={{
                    top: 20,
                    right: 60,
                    bottom: 20,
                  }}
                  barGap={2}
                  barCategoryGap={10}
                  maxBarSize={40}
                >
                  <CartesianGrid strokeDasharray="" vertical={false} opacity={0.5} />
                  <XAxis dataKey="name" stroke="var(--secondary)" />
                  <YAxis
                    width={100}
                    stroke="var(--secondary)"
                    tickFormatter={(value: any, index: number) =>
                      value === 0 ? '' : value.toLocaleString('en-US').replaceAll(',', ' ')
                    }
                    tickCount={5}
                  />
                  <Tooltip
                    cursor={{ fill: 'none' }}
                    content={(props) => (
                      <div
                        className="flex  bg-opacity-95 rounded-sm p-8 gap-3"
                        style={{ backgroundColor: 'var(--background)' }}
                      >
                        <p>{`${props.label}`}</p>
                        {props.payload && props.payload[0] && (
                          <>
                            <p>-</p>
                            <p style={{ color: props.payload[0].color }}>
                              {parseFloat(`${props.payload[0].value}`)}
                            </p>
                          </>
                        )}
                      </div>
                    )}
                  />
                  <ReferenceLine y={0} stroke="var(--secondary)" />

                  <Bar
                    dataKey="value"
                    fill="var(--primary)"
                    background={{ fill: 'var(--primary)', opacity: 0.2 }}
                    radius={[4, 4, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            )}
          </Container.Content>
        </Container>
      </div>
      <div className="flex justify-between items-center gap-4 w-full mt-4">
        <p className="pl-[1rem] opacity-65">Najlepsze wydania</p>
        <div className="flex gap-2">
          <Button
            onlyIcon
            variant={BUTTON_VARIANT.white}
            // onClick={() => setReleasesPage((prev) => prev - 1)}
            // disabled={releasesPage < 1}
          >
            <Button.Icon icon={<PiCaretLeft />} />
          </Button>

          <Button
            onlyIcon
            variant={BUTTON_VARIANT.white}
            // onClick={() => setReleasesPage((prev) => prev + 1)}
            // disabled={(digitalReleases.data?.pages.flat().length ?? 0) < 6}
          >
            <Button.Icon icon={<PiCaretRight />} />
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-4 w-full">
        {digitalReleases.map((d) => (
          <ReleaseCard key={d.id} title={d.mainTitle} cover={d.cover ?? ''} onClick={() => {}} />
        ))}
      </div>
      <div className="flex flex-col gap-4 w-full pb-[32px] pt-[16px] items-start md:flex-row">
        <Container className="">
          <Container.Header
            title={
              <div className=" flex w-full justify-between">
                <div className="flex gap-2">
                  <PiGlobeHemisphereEast /> Gdzie odtwarzają twoi słuchacze?
                </div>
              </div>
            }
          />
          <Container.Content style={{ backgroundColor: 'var(--background)', padding: '20px' }}>
            <World activeCountries={countriesViews.map((c) => c.name)} />
          </Container.Content>
        </Container>
        <Container className="w-full">
          <Container.Header
            title={
              <div className=" flex w-full justify-between">
                <div className="flex gap-2">
                  <PiChartBarHorizontal /> Kraje w których słucha się najczęściej?
                </div>
              </div>
            }
          />
          <Container.Content style={{ backgroundColor: 'var(--background)', padding: '20px 0px' }}>
            <ResponsiveContainer height={365}>
              <BarChart
                layout="vertical"
                data={countriesViews}
                margin={{
                  top: 20,
                  right: 60,
                  bottom: 20,
                }}
                barGap={2}
                barCategoryGap={6}
                maxBarSize={40}
              >
                {/* <CartesianGrid strokeDasharray="" vertical={false} opacity={0.5} /> */}
                <XAxis
                  type="number"
                  stroke="var(--secondary)"
                  tickFormatter={(value: any) =>
                    value === 0 ? '' : value.toLocaleString('en-US').replaceAll(',', ' ')
                  }
                />
                <YAxis
                  type="category"
                  dataKey="name"
                  width={150}
                  stroke="var(--secondary)"
                  tickFormatter={(value) => t(`countries.${value}`)}
                />
                <Tooltip
                  cursor={{ fill: 'none' }}
                  content={(props) => (
                    <div
                      className="flex  bg-opacity-95 rounded-sm p-8 gap-3"
                      style={{ backgroundColor: 'var(--background)' }}
                    >
                      <p>{`${props.label}`}</p>
                      {props.payload && props.payload[0] && (
                        <>
                          <p>-</p>
                          <p style={{ color: props.payload[0].color }}>
                            {parseFloat(`${props.payload[0].value}`)
                              .toLocaleString('en-US')
                              .replaceAll(',', ' ')}
                          </p>
                        </>
                      )}
                    </div>
                  )}
                />
                <ReferenceLine y={0} stroke="var(--secondary)" />

                <Bar
                  dataKey="value"
                  fill="var(--primary)"
                  background={{ fill: 'var(--primary)', opacity: 0.2 }}
                  radius={[0, 4, 4, 0]}
                />
              </BarChart>
            </ResponsiveContainer>
          </Container.Content>
        </Container>
      </div>
    </TopbarPage>
  );
};

export default Dashboatrd;

const generateCountryViews = () => {
  const TOTAL_VIEWS = 5000000;
  const POLAND_VIEWS = 2123907;
  const REMAINING_VIEWS = TOTAL_VIEWS - POLAND_VIEWS;
  const MIN_VALUE = 80000;

  const countryCodes = ['US', 'DE', 'GB', 'FR', 'IT', 'ES', 'NL', 'BE', 'CZ', 'SK'];

  const countriesCount = countryCodes.length;

  // Sprawdzenie czy minValue jest możliwe
  const minRequired = countriesCount * MIN_VALUE;

  if (minRequired > REMAINING_VIEWS) {
    throw new Error(
      `minValue (${MIN_VALUE}) jest za duże. Maksymalne możliwe to ${Math.floor(
        REMAINING_VIEWS / countriesCount,
      )}`,
    );
  }

  // Pula do losowego podziału
  const randomPool = REMAINING_VIEWS - minRequired;

  // Losowe punkty podziału
  const cuts = Array.from({ length: countriesCount - 1 }, () =>
    Math.floor(Math.random() * randomPool),
  ).sort((a, b) => a - b);

  const distributedValues: number[] = [];
  let previousCut = 0;

  for (let i = 0; i < cuts.length; i++) {
    distributedValues.push(cuts[i] - previousCut);
    previousCut = cuts[i];
  }

  distributedValues.push(randomPool - previousCut);

  // Dodajemy minValue do każdego kraju
  const otherCountries = countryCodes.map((code, index) => ({
    name: code,
    value: distributedValues[index] + MIN_VALUE,
  }));

  const result = [...otherCountries, { name: 'PL', value: POLAND_VIEWS }];

  return result.sort((a, b) => b.value - a.value);
};

const digitalReleases = [
  {
    id: '6',
    mainTitle: { title: 'Vintage Gold', version: 'Kolekcjonerska', language: 1 },
    cover:
      'https://d1csarkz8obe9u.cloudfront.net/posterpreviews/album-cover-design-template-1ddc6804b8e270cc62ae7e92efcafd47_screen.jpg?ts=1714372232',
  },
  {
    id: '1',
    mainTitle: { title: 'Zima', version: 'Standard', language: 1 },
    cover:
      'https://d1csarkz8obe9u.cloudfront.net/posterpreviews/artistic-album-cover-design-template-d12ef0296af80b58363dc0deef077ecc_screen.jpg?ts=1735798846',
  },
  {
    id: '2',
    mainTitle: { title: 'Daylight', version: 'Standard', language: 1 },
    cover:
      'https://d1csarkz8obe9u.cloudfront.net/posterpreviews/square-abstract-album-cover-template-design-bd514bc801c075669ff5a247cc4c91e3_screen.jpg?ts=1736090789',
  },
  {
    id: '3',
    mainTitle: { title: 'Ulica', version: 'Deluxe', language: 1 },
    cover:
      'https://d1csarkz8obe9u.cloudfront.net/posterpreviews/romantic-love-song-album-cover-design-template-62d2673d68489c5ba97db2fd7db5c705_screen.jpg?ts=1698301453',
  },
  {
    id: '4',
    mainTitle: { title: 'Transparent', version: 'Kolekcjonerska', language: 1 },
    cover:
      'https://d1csarkz8obe9u.cloudfront.net/posterpreviews/cd-mixtape-album-cover-design-template-58000bb029c76539a6293b4e3d6deea5_239b3ca0-0fc3-43f8-ba60-419678ca74e6_screen.png?ts=1771474598',
  },
  {
    id: '5',
    mainTitle: { title: 'Trasa', version: 'Deluxe', language: 1 },
    cover:
      'https://d1csarkz8obe9u.cloudfront.net/posterpreviews/black-maximalist-street-dark-album-cover-design-template-e558279f1d2df766ae8e8cc18e6a06cf_screen.jpg?ts=1756640783',
  },
];
